var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrivacyPolicyActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11329",
    "data-name": "Path 11329",
    d: "M29.692,29.231H2V5H29.692ZM3.154,28.077H28.538V6.154H3.154Z",
    transform: "translate(-0.846 -2.115)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3817",
    "data-name": "Rectangle 3817",
    width: 26,
    height: 1,
    transform: "translate(2 7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3818",
    "data-name": "Rectangle 3818",
    width: 1,
    height: 1,
    transform: "translate(4 5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3819",
    "data-name": "Rectangle 3819",
    width: 1,
    height: 1,
    transform: "translate(6 5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3820",
    "data-name": "Rectangle 3820",
    width: 1,
    height: 1,
    transform: "translate(8 5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11330",
    "data-name": "Path 11330",
    d: "M26.456,24.091,24.725,18.9c-.208-.727-.317-.762-.606-.762H19.5c-.288,0-.4.035-.577.738L17.2,24.068,16.1,23.7l1.731-5.192a1.75,1.75,0,0,1,1.7-1.546h4.615c1.252,0,1.546,1.021,1.731,1.569l1.731,5.192Z",
    transform: "translate(-6.812 -7.175)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3821",
    "data-name": "Rectangle 3821",
    width: 18,
    height: 1,
    transform: "translate(6 16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11331",
    "data-name": "Path 11331",
    d: "M29.885,36.769a2.885,2.885,0,1,1,2.885-2.885,2.885,2.885,0,0,1-2.885,2.885Zm0-4.615a1.731,1.731,0,1,0,1.731,1.731A1.731,1.731,0,0,0,29.885,32.154Z",
    transform: "translate(-11.423 -13.115)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11332",
    "data-name": "Path 11332",
    d: "M17.885,36.769a2.885,2.885,0,1,1,2.885-2.885,2.885,2.885,0,0,1-2.885,2.885Zm0-4.615a1.731,1.731,0,1,0,1.731,1.731A1.731,1.731,0,0,0,17.885,32.154Z",
    transform: "translate(-6.346 -13.115)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11333",
    "data-name": "Path 11333",
    d: "M25.6,34.138l-.744-.75-.744.75-.819-.819,1.154-1.154a.577.577,0,0,1,.819,0l1.154,1.154Z",
    transform: "translate(-9.853 -13.536)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3822",
    "data-name": "Rectangle 3822",
    width: 30,
    height: 30,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyPolicyActive);
export default __webpack_public_path__ + "static/media/privacyPolicy-active.918cb2d75c1aed5f93af96030b516ac1.svg";
export { ForwardRef as ReactComponent };